import React from 'react';
import { Link } from 'react-router-dom';
import Icon from 'components/AppIcon';

const SuccessState = ({ email }) => {
  return (
    <div className="text-center">
      <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-5">
        <Icon name="MailCheck" size={32} className="text-green-600" />
      </div>

      <h2 className="text-xl font-heading font-semibold text-text-primary mb-3">Check Your Email</h2>

      <p className="text-sm text-text-secondary leading-relaxed mb-2">
        We've sent a password reset link to:
      </p>
      <p className="text-sm font-semibold text-text-primary mb-5 bg-background px-4 py-2 rounded-lg border border-border inline-block">
        {email}
      </p>

      <div className="space-y-3 text-sm text-text-secondary text-left bg-background rounded-lg border border-border p-4 mb-6">
        <div className="flex items-start gap-3">
          <div className="w-5 h-5 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0 mt-0.5">
            <span className="text-primary text-xs font-bold">1</span>
          </div>
          <span>Open the email from <strong>LawDesk KE</strong> in your inbox</span>
        </div>
        <div className="flex items-start gap-3">
          <div className="w-5 h-5 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0 mt-0.5">
            <span className="text-primary text-xs font-bold">2</span>
          </div>
          <span>Click the <strong>Reset My Password</strong> button in the email</span>
        </div>
        <div className="flex items-start gap-3">
          <div className="w-5 h-5 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0 mt-0.5">
            <span className="text-primary text-xs font-bold">3</span>
          </div>
          <span>Create your new password on the secure reset page</span>
        </div>
      </div>

      <p className="text-xs text-text-secondary mb-5">
        Didn't receive the email? Check your spam folder or{' '}
        <Link to="/forgot-password-request" className="text-primary hover:underline font-medium">
          try again
        </Link>
        .
      </p>

      <Link
        to="/login"
        className="inline-flex items-center gap-2 text-sm text-primary hover:text-primary-700 font-medium transition-smooth"
      >
        <Icon name="ArrowLeft" size={16} />
        Return to Sign In
      </Link>
    </div>
  );
};

export default SuccessState;